import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Format a number with a fixed decimal count, falling back to "—" for nullish. */
export function fmtNum(v: number | null | undefined, digits = 1): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return v.toFixed(digits);
}

/** Format meters as "12.3 m" or " 1.2 km" depending on magnitude. */
export function fmtMeters(v: number | null | undefined): string {
  if (v == null) return '—';
  if (Math.abs(v) >= 1000) return `${(v / 1000).toFixed(2)} km`;
  return `${v.toFixed(1)} m`;
}

/** Coordinates as "47.39770°, 8.54560°". */
export function fmtLatLon(lat: number, lon: number): string {
  return `${lat.toFixed(5)}°, ${lon.toFixed(5)}°`;
}

/** Distance in the operator's chosen unit (Settings → Map → Distance unit).
 *  'm' → whole metres; 'km' → 2-decimal kilometres. */
export function fmtDistance(v: number, unit: 'm' | 'km'): string {
  if (unit === 'km') return `${(v / 1000).toFixed(2)} km`;
  return `${Math.round(v)} m`;
}
